export default {
  refcode: false,
  refcode2: false,
  showBanner: true,
}
